import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useDispatch } from 'react-redux';
import FormularioPrincipal from './formularios'
import { useLocation } from 'react-router-dom'
import { configuracionFormAction8, obtenerAntecedentesCaso} from "../../store/actions/encargado-cia-action";
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CasoGeneralComponent } from 'recupero-caso-general'

const PrepararCartaCobro = () => {
const [loading, setLoading] = useState(false);
 const {  rutOrganizacion } = Auth.currentUser()
 const {state}=useLocation()
 const dispatch=useDispatch()
 const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:119
 const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado:1
 const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:99061000
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  
 
  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(JSON.stringify({ "idform": 8, "rutcia": rutOrganizacion })).toString('base64');
    dispatch(configuracionFormAction8(query));

}, [dispatch]);

useEffect(() => {
  if (idCasoLocation && idOrganizacionCaso) {
    setLoading(true)
    let query = Buffer.from(
      JSON.stringify({
        idOrgCaso: idOrganizacionCaso,
        idCaso: idCasoLocation
      })
    ).toString('base64')
    dispatch(obtenerAntecedentesCaso(query));
  }
}, [dispatch]); 

  return (
    <Container>
      <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                {`Iniciar Recobro entre Compañías, Caso: ${idCasoLocation}`}
                </Card.Header>
                <Card.Body>
                    <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso}/>                     
                </Card.Body>
            </Card>      
           <FormularioPrincipal        
           />
        </Container>                 
    </Container>
  )
}
export default PrepararCartaCobro
